module.exports = __webpack_public_path__ + "static/media/android.a816dda6.svg";